// extracted by mini-css-extract-plugin
export var dismissOverlay = "_fo-b";
export var interactivePassthrough = "_fo-3";
export var modal = "_fo-d";
export var modalBackdrop = "_fo-c";
export var modalBody = "_fo-j";
export var modalDescription = "_fo-m";
export var modalEnter = "_fo-e";
export var modalFooter = "_fo-n";
export var modalHeaderText = "_fo-h";
export var modalIconCircle = "_fo-i";
export var modalIconHeader = "_fo-g";
export var modalImage = "_fo-f";
export var modalSectionLabel = "_fo-k";
export var modalTitle = "_fo-l";
export var pulse = "_fo-1";
export var pulseBorder = "_fo-2";
export var spotlight = "_fo-0";
export var tooltip = "_fo-4";
export var tooltipButtons = "_fo-9";
export var tooltipDescription = "_fo-6";
export var tooltipFooter = "_fo-7";
export var tooltipInteractivePill = "_fo-a";
export var tooltipStepIndicator = "_fo-8";
export var tooltipTitle = "_fo-5";